import { Pipe, PipeTransform } from '@angular/core';
import { TenantDto } from '../../api/core/models/tenant-dto';

@Pipe({
    name: 'liebherrTenantNameByPath',
})
export class GetTenantNameByPathPipe implements PipeTransform {
    transform(path: string, tenants: TenantDto[]) {
        return tenants?.find((t) => (t.serviceKey ? path?.endsWith('/' + t.serviceKey?.toString()) : false))?.name || '-';
    }
}
